import { gql } from "@apollo/client";

export const SystemNameplateInfo = gql`
    query SystemNameplateInfo($id: ID\!) {
        system(id: $id) {
            id
            title
            systemType
            installedBaseNode {
                id
                key
                title
                access {
                    id
                    write
                }
                image {
                    id
                    file {
                        id
                        thumbnailLink(crop: fit, w: 200, h: 200)
                    }
                }
            }
            client {
                id
                industryType
            }
        }
    }
`;
